import { render } from "./HelloWorld.vue?vue&type=template&id=b8ed54b2&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=b8ed54b2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b8ed54b2"

export default script